import { render, staticRenderFns } from "./jiaoxueDialog.vue?vue&type=template&id=40b25057&scoped=true"
import script from "./jiaoxueDialog.vue?vue&type=script&lang=js"
export * from "./jiaoxueDialog.vue?vue&type=script&lang=js"
import style0 from "./jiaoxueDialog.vue?vue&type=style&index=0&id=40b25057&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b25057",
  null
  
)

export default component.exports